'use strict';
var Marionette = require('backbone.marionette');
var Radio = require('backbone.radio');
var polyglot = require('../../utilities/polyglot').default;
var $ = require('jquery');
var _ = require('underscore');
var Tracker = require('../../../analytics/events').default;
var TitleView = require('../step-title').default;
var CalendarView = require('../times/calendar').default;
var GroupView = require('../group-appointments/list-container').default;
var GroupAppointmentCollection = require('../../collections/group-appointments').default;
var LocationCollection = require('../../collections/locations').default;
var ServicesCollection = require('../../collections/services').default;
var StaffCollection = require('../../collections/staff').default;
var TimesCollection = require('../../collections/times').default;
var Appointment = require('../../models/appointment').default;

export default Marionette.View.extend({

  className: 'l-reschedule',
  template: require('./templates/reschedule.hbs'),
  defaultErrorMessage: polyglot.t('reschedule.error'),
  regions: function() {
    return {
      title:    '.' + this.className + '-title',
      calendar: '.' + this.className + '-calendar',
    }
  },

  initialize: function(options) {
    Tracker.trackView('reschedule');
    this.appointment = options.appointment;
    this.services = new ServicesCollection([this.appointment.services]);
    if (this.appointment.staff) {
      this.staff =  new StaffCollection([this.appointment.staff]);
    } else {
      this.staff = new StaffCollection();
      this.fetchStaff();
    }
    this.locations = new LocationCollection([this.appointment.location]);
    this.times = new TimesCollection();

    // original values to restore appointment on going back
    this.originalStart = this.appointment.get('start');
    this.originalCookieTimezone = window.localStorage.getItem('timezone');

    this.titleView = new TitleView({
      title: polyglot.t('pages.reschedule.title'),
    });

    if (this.appointment.isGroup()) {
      this.calendarView = new GroupView({
        collection:  new GroupAppointmentCollection(),
        appointment: this.appointment,
        locations:   this.locations,
        services:    this.services,
        staff:       this.staff,
      });
    } else {
      this.calendarView = new CalendarView({
        collection:  this.times,
        appointment: this.appointment,
        locations:   this.locations,
        services:    this.services,
        staff:       this.staff,
      });
    }

    this.listenTo(Radio.channel('steps'), 'click:update', this.onSubmit);
    this.listenTo(Radio.channel('steps'), 'click:back', this.onBack);
  },

  onRender: function() {
    this.getRegion('title').show(this.titleView);
    this.getRegion('calendar').show(this.calendarView);
    this.calendarView.fetchTimes(this.staff.first());
  },

  onDomRefresh: function() {
    if (this.appointment.isPrivate()) {
      this.calendarView.hideLoadingView();
    }
  },

  fetchStaff: function() {
    var self = this;
    this.staff.fetch({
      data: {
        location_id: this.appointment.get('location_id'),
        service_id: this.appointment.get('service_id'),
      },
      reset: true,
      success: function(collection, data) {
        self.calendarView.hideLoadingView();
        if (data.data.staff.length === 0) {
          $('.calendar-empty').show();
        }
      }
    });
  },

  onSubmit: function () {
    this.trigger('change');

    if (!this.appointment.canCancel(this.originalStart)) {
      this.resetAppointment();
      Radio.channel('reschedule').trigger('set:here', false);
      Radio.channel('confirm').trigger('confirm:message', null);
      Backbone.history.navigate(polyglot.t('pages.confirmation.slug'), {trigger: true});
    } else if (this.isValid()) {
      this.disableSubmit();
      this.onFormSubmit();
    } else if (this.appointment.validationError.toast) {
      Radio.channel('toast').trigger('show', {
        message: this.appointment.validationError.toast,
        icon: 'times-circle',
        iconColor: 'error',
      });
    } else {
      Radio.channel('toast').trigger('show', {
        message: polyglot.t('reschedule.error.time'),
        icon: 'times-circle',
        iconColor: 'error',
      });
    }
  },

  onFormSubmit: function() {
    this.appointment.set('client_timezone', window.localStorage.getItem('timezone'));

    this.appointment.reschedule()
      .done(_.bind(this.onSaveSuccess, this))
      .fail(_.bind(this.onSaveError, this));
  },

  enableSubmit: function () {
    Radio.channel('buttons').request('update:enable');
  },

  disableSubmit: function () {
    Radio.channel('buttons').request('update:disable');
  },

  onSaveSuccess: function (data, textStatus, jqXHR) {
    window.APPOINTMENTS = _.map(data.data.appointment, function(appointment) {
      return new Appointment(appointment);
    });
    this.enableSubmit();
    Radio.channel('reschedule').trigger('set:here', false);
    Radio.channel('confirm').trigger('confirm:message', polyglot.t('pages.reschedule.long_title'));
    Backbone.history.navigate(polyglot.t('pages.confirmation.slug'), {trigger: true});
  },

  onSaveError: function (jqXHR, textStatus, errorThrown) {
    this.enableSubmit();

    var errorData = jqXHR.responseJSON.data;
    if (errorData) {
      if (errorData.d || errorData.ttendee_id || errorData.ocation_id || errorData.ervice_id) {
        // Appointment has been cancelled
        window.APPOINTMENTS = [];
        Radio.channel('reschedule').trigger('set:here', false);
        Backbone.history.navigate(polyglot.t('pages.confirmation.slug'), {trigger: true});
      } else if (errorData.staff) {
        // Appointment has been reassigned to a different staff
        this.appointment.staff = new Backbone.Model(errorData.staff);
        this.appointment.set('staff_id', errorData.staff.id);
        this.staff = new StaffCollection([this.appointment.staff]);
        this.calendarView.staff = this.staff;
        this.calendarView.fetchTimes(false);
        Radio.channel('toast').trigger('show', {
          message: errorData.message,
          iconColor: 'error',
        });
      } else {
        // The selected timeslot is no longer available
        this.calendarView.fetchTimes(false);
        Radio.channel('toast').trigger('show', {
          message: errorData.tart ? errorData.tart[0] : this.defaultErrorMessage,
          iconColor: 'error'
        });
      }
    } else {
      // Any other error
      this.calendarView.fetchTimes(false);
      Radio.channel('toast').trigger('show', {
        message: jqXHR.responseJSON.message ?
          jqXHR.responseJSON.message :
          this.defaultErrorMessage,
        iconColor: 'error'
      });
    }
  },

  isValid: function () {
    return this.appointment.isValid({
      step: polyglot.t('pages.reschedule.slug'),
      originalStart: this.originalStart
    });
  },

  resetAppointment: function() {
    this.appointment.set('start', this.originalStart);
    window.localStorage.setItem('timezone', this.originalCookieTimezone);
  },

  onBack: function() {
    this.resetAppointment();
    Radio.channel('reschedule').trigger('set:here', false);
    Radio.channel('confirm').trigger('confirm:message', null);
    Backbone.history.history.back();
  },
});
